// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { function16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-function': IconFunction;
    }
}

/**
 * The icon component for the 'function' icon
 */
export class IconFunction extends Icon {
    public constructor() {
        super(function16X16);
    }
}

registerIcon('icon-function', IconFunction);
export const iconFunctionTag = 'nimble-icon-function';
